export const API_BASE_URL = window.location.origin
